"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportDialogHook = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const react_intl_1 = require("react-intl");
const snackbar_types_1 = require("../../../../../composite/snackbar/snackbar-types");
const snackbar_context_1 = require("../../../../../composite/snackbar/snackbar-context");
const crud_source_hook_1 = require("../../../../../utils/crud-source-hook");
const event_callback_hook_1 = require("../../../../../utils/event-callback-hook");
const sleep_1 = require("../../../../../utils/sleep");
const export_types_1 = require("../../../export-types");
const export_context_1 = require("../../../export-context");
const export_api_1 = require("../../../export-api");
function useExportDialogHook(tag, provideData) {
    const { url } = react_1.useContext(export_context_1.ExportContext);
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const intl = react_intl_1.useIntl();
    const [asyncLoading, setAsyncLoading] = react_1.useState(false);
    const [loading, setLoading] = react_1.useState(false);
    const [state, setState] = react_1.useState(undefined);
    const [resultId, setResultId] = react_1.useState();
    const ref = react_1.useRef(null);
    const [selectedFormat, setSelectedFormat] = react_1.useState(export_types_1.ExportType.PDF);
    const [selectedTemplate, setSelectedTemplate,] = react_1.useState(null);
    const templateSource = export_api_1.useTemplates(tag);
    const requestSource = crud_source_hook_1.useCrudSource({
        url: `${url}/requests`,
        createMessages: {
            successMessage: intl.formatMessage({
                id: 'EAS_EXPORT_DIALOG_MSG_SUCCESS',
                defaultMessage: 'Požadavek na export byl zařazen do fronty.',
            }),
            errorMessage: intl.formatMessage({
                id: 'EAS_EXPORT_DIALOG_MSG_ERROR',
                defaultMessage: 'Nastala chyba při vytváření požadavku na export: {detail}.',
            }),
        },
    });
    const selectTemplate = event_callback_hook_1.useEventCallback((template) => {
        setSelectedTemplate(template);
        setSelectedFormat(null);
    });
    const generateSync = event_callback_hook_1.useEventCallback(async () => {
        var _a, _b;
        react_dom_1.unstable_batchedUpdates(() => {
            setState(undefined);
            setLoading(true);
        });
        await submitRequest();
        setState((_a = requestSource.data) === null || _a === void 0 ? void 0 : _a.state);
        let state;
        let data;
        try {
            do {
                await sleep_1.sleep(2000);
                data = await requestSource.refresh();
                state = data === null || data === void 0 ? void 0 : data.state;
                setState(state);
            } while (state === export_types_1.ExportRequestState.PENDING ||
                state === export_types_1.ExportRequestState.PROCESSING);
        }
        finally {
            setLoading(false);
        }
        if (state === export_types_1.ExportRequestState.PROCESSED) {
            const message = intl.formatMessage({
                id: 'EAS_EXPORT_DIALOG_MSG_SYNC_GENERATED_SUCCESS',
                defaultMessage: 'Export byl vygenerován. Můžete ho stáhnout.',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
            setResultId((_b = data === null || data === void 0 ? void 0 : data.result) === null || _b === void 0 ? void 0 : _b.id);
        }
        else if (state === export_types_1.ExportRequestState.FAILED) {
            const message = intl.formatMessage({
                id: 'EAS_EXPORT_DIALOG_MSG_SYNC_GENERATED_ERROR',
                defaultMessage: 'Nastala chyba při generování exportu: {detail}.',
            }, {
                detail: data === null || data === void 0 ? void 0 : data.message,
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
            setResultId(undefined);
        }
    });
    const downloadSync = event_callback_hook_1.useEventCallback(() => {
        setState(undefined);
    });
    const generateASync = event_callback_hook_1.useEventCallback(async () => {
        var _a;
        setAsyncLoading(true);
        try {
            await submitRequest();
        }
        finally {
            setAsyncLoading(false);
        }
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
    });
    const submitRequest = event_callback_hook_1.useEventCallback(async () => {
        if (selectedTemplate === null) {
            const message = intl.formatMessage({
                id: 'EAS_EXPORT_DIALOG_MSG_MISSING_TEMPLATE_ERROR',
                defaultMessage: 'Není vybraná šablona',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
            return false;
        }
        if (selectedFormat === null) {
            const message = intl.formatMessage({
                id: 'EAS_EXPORT_DIALOG_MSG_MISSING_FORMAT_ERROR',
                defaultMessage: 'Není vybrán formát',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
            return false;
        }
        const request = {
            id: '',
            template: selectedTemplate !== null && selectedTemplate !== void 0 ? selectedTemplate : undefined,
            type: selectedFormat,
            configuration: JSON.stringify(provideData()),
        };
        await requestSource.create(request);
    });
    const columns = react_1.useMemo(() => [
        {
            name: 'Název',
            datakey: 'label',
            width: 500,
            visible: true,
        },
    ], []);
    const syncLoading = state === export_types_1.ExportRequestState.PENDING ||
        state === export_types_1.ExportRequestState.PROCESSING;
    return {
        loading,
        state,
        ref,
        asyncLoading,
        syncLoading,
        columns,
        templates: templateSource.items,
        selectedFormat,
        selectedTemplate,
        resultId,
        setSelectedFormat,
        selectTemplate,
        generateSync,
        generateASync,
        downloadSync,
    };
}
exports.useExportDialogHook = useExportDialogHook;
//# sourceMappingURL=export-dialog-hook.js.map